import clsx from "clsx";
import "./ChangeProfileModalContent.scss";

type ChangeProfileModalContentProps = {
  overrideClassNames?: string;
  children?: React.ReactNode;
};

export const ChangeProfileModalContent = ({
  overrideClassNames,
  children,
}: ChangeProfileModalContentProps) => {
  return (
    <div className={clsx("ui-consent-modal-body", overrideClassNames)}>
      {children}
    </div>
  );
};
